<template>
  <!-- The reports--index Stimulus search filters the cards by their
       data-report-name and toggles this section via the target. -->
  <section
    v-if="reports.length > 0"
    class="tw-flex tw-flex-col"
    data-testid="pinned-reports"
    data-reports--index-target="pinnedSection"
  >
    <div
      class="
        tw-uppercase
        tw-text-center
        tw-text-xs
        tw-tracking-wider
        tw-text-sf-neutral-light-1
        tw-my-4
      "
    >
      {{ I18n.t('report.drawer.pin_to_top.section_title') }}
    </div>
    <div class="tw-flex tw-flex-wrap tw-gap-4">
      <PinnedReportCard
        v-for="report in reports"
        :key="report.reportTemplateId"
        class="tw-grow tw-basis-[calc(33.333%-0.667rem)] tw-min-w-0"
        :data-report-name="report.name"
        :report-template-id="report.reportTemplateId"
        :name="report.name"
        :locale="report.locale"
        :path="report.path"
        :pinned="report.pinned"
        :highlighted="report.highlighted"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import PinnedReportCard from '@app/application/report/components/pinned-report-card.vue'
import type { PinnedReport } from '@app/application/report/types'
import useI18n from '@app/shared/vue/composables/use-I18n'

defineOptions({ name: 'PinnedReports' })

defineProps<{
  reports: PinnedReport[]
}>()

const I18n = useI18n()
</script>
